<div class="container-md">
    <div class="mt-3 mb-3 ms-2" *ngIf="result==1">
        <div>
            <label class="fw-bold activation">{{ 'IDS_CORRECT_ACTIVATION' | translate }}</label>
        </div>
        <div>
            <button type="button" class="mt-2 fw-bold text-uppercase btn-gold" routerLink="/home" *ngIf="!slug">{{ 'IDS_GO_TO_HOMEPAGE' | translate }}</button>
            <button type="button" class="mt-2 fw-bold text-uppercase btn-gold" [routerLink]="['/', 'eventnow', slug]" *ngIf="slug">{{ 'IDS_GO_TO_EVENT' | translate }}</button>
        </div>
    </div>
</div>
